export const ClientsListingGetters = {
  ClientsList: 'clientsList',
  ClientsRecordsPerPage: 'clientsRecordsPerpage',
  ClientsRecordsOffset: 'clientsRecordsOffset',
  ClientsRecordsCount: 'clientsRecordsCount',
  ClientsSortField: 'clientsSortField',
  ClientsSortDirection: 'clientsSortDirection',
  ClientsFilterPreference: 'clientsFilterPreference',
  ClientsTypeFilterPreference: 'clientsTypeFilterPreference'
};

export const ClientsListingMutations = {
  SetClientsList: 'setClientList',
  SetRecordsCount: 'setClientsRecordsCount',
  SetPaginationParameters: 'setClientsPaginationParameters',
  SetSortParameters: 'setClientsSortParameters',
  SetClientsFilterPreference: 'setClientsFilterPreference',
  SetClientsTypeFilterPreference: 'setClientsTypeFilterPreference',
  ResetPaginationPropertyOffset: 'resetPaginationPropertyOffset',
  SetClientsSearchParam: 'setClientsSearchParam'
};

export const ClientsListingActions = {
  RetrieveClientsList: 'retrieveClientsList',
  PaginationParametersUpdate: 'paginationParametersUpdate',
  SortingParametersUpdate: 'sortingParametersUpdate',
  ClientsFilterPreferenceUpdate: 'updateClientsStatusFilterPreference',
  ClientsTypeFilterPreferenceUpdate: 'updateClientsTypeFilterPreference',
  DownloadClientsListAsExcel: 'downloadClientsListAsExcel',
  UpdateClientsList: 'updateClientsList',
  RetrieveClientRecordCount: 'ClientsListingActions.RetrieveClientRecordCount'
};
